var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-tile"},[_c('img',{staticClass:"grid-thumb",attrs:{"alt":"image thumbnail","height":"150","src":_vm.media.signed_thumb_url}}),_c('div',{staticClass:"grid-label"},[_vm._v("\n    "+_vm._s(_vm.media.name)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }